export default __webpack_public_path__ + "static/media/lessons-illustration2.fd40bcf2.svg";